// import React, { useState, useEffect } from 'react';
// import {
//   ClipboardCheck,
//   AlertCircle,
// } from 'lucide-react';
// import api from '../../services/api';
// import LoadingSpinner from '../common/LoadingSpinner';
// import { useNavigate } from 'react-router-dom';
// import useAdminSidebarCounts from '../../hooks/useAdminSidebarCounts';

// const getLocalDateString = () => {
//   const now = new Date();
//   const year = now.getFullYear();
//   const month = String(now.getMonth() + 1).padStart(2, '0');
//   const day = String(now.getDate()).padStart(2, '0');
//   return `${year}-${month}-${day}`;
// };

// const normalizeAttendanceStatus = (attendance) => {
//   if (attendance?.status === 'full-day' || attendance?.status === 'half-day') {
//     return attendance.status;
//   }
//   if (attendance?.checkInTime && !attendance?.checkOutTime) {
//     return 'checked-in';
//   }
//   if (attendance?.checkInTime && attendance?.checkOutTime) {
//     return attendance?.totalHours >= 8 ? 'full-day' : 'half-day';
//   }
//   return 'absent';
// };

// const Dashboard = () => {
//   const [dashboardData, setDashboardData] = useState(null);
//   const [todayAttendanceStats, setTodayAttendanceStats] = useState({
//     fullDay: 0,
//     halfDay: 0,
//     absent: 0,
//     checkedIn: 0,
//     present: 0
//   });
//   const [loading, setLoading] = useState(true);
//   const navigate = useNavigate();
//   const { counts } = useAdminSidebarCounts();
//   useEffect(() => {
//     fetchDashboardData();
//     fetchTodayAttendanceStats();
//   }, []);

//   const fetchDashboardData = async () => {
//     try {
//       const response = await api.get('/admin/dashboard');
//       setDashboardData(response.data);
//     } catch (error) {
//       console.error('Error fetching dashboard data:', error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const fetchTodayAttendanceStats = async () => {
//     try {
//       const todayDateString = getLocalDateString();
//       const response = await api.get(`/admin/attendance/date/${todayDateString}`);
//       const data = response.data.attendances || [];

//       const fullDay = data.filter((a) => normalizeAttendanceStatus(a) === 'full-day').length;
//       const halfDay = data.filter((a) => normalizeAttendanceStatus(a) === 'half-day').length;
//       const absent = data.filter((a) => normalizeAttendanceStatus(a) === 'absent').length;
//       const checkedIn = data.filter((a) => normalizeAttendanceStatus(a) === 'checked-in').length;

//       setTodayAttendanceStats({
//         fullDay,
//         halfDay,
//         absent,
//         checkedIn,
//         present: fullDay + halfDay + checkedIn
//       });
//     } catch (error) {
//       console.error('Error fetching today attendance stats:', error);
//     }
//   };

//   if (loading) {
//     return <LoadingSpinner size="lg" className="mt-8" />;
//   }

//   const { statistics, recentActivities } = dashboardData || {};
//   const todayDateString = getLocalDateString();

//   const attendanceCards = [
//     {
//       title: 'Present',
//       value: todayAttendanceStats.present,
//       color: 'text-emerald-600',
//       bg: 'bg-emerald-50 border-emerald-200',
//       filter: 'present'
//     },
//     {
//       title: 'Full Day',
//       value: todayAttendanceStats.fullDay,
//       color: 'text-green-600',
//       bg: 'bg-green-50 border-green-200',
//       filter: 'full-day'
//     },
//     {
//       title: 'Absent',
//       value: todayAttendanceStats.absent,
//       color: 'text-red-600',
//       bg: 'bg-red-50 border-red-200',
//       filter: 'absent'
//     },
//     {
//       title: 'Half Day',
//       value: todayAttendanceStats.halfDay,
//       color: 'text-yellow-600',
//       bg: 'bg-yellow-50 border-yellow-200',
//       filter: 'half-day'
//     },
//     {
//       title: 'Checked In',
//       value: todayAttendanceStats.checkedIn,
//       color: 'text-blue-600',
//       bg: 'bg-blue-50 border-blue-200',
//       filter: 'checked-in'
//     }
//   ];

//   const actionableRequests = [
//     {
//       title: 'Leave Applications',
//       subtitle: 'Pending approvals',
//       count: counts.leavePending ?? statistics?.pendingLeaves ?? 0,
//       path: '/admin/leaves',
//       color: 'bg-yellow-50 border-yellow-200 text-yellow-800',
//       dot: 'bg-yellow-500'
//     },
//     {
//       title: 'WFH Applications',
//       subtitle: 'Pending work from home requests',
//       count: counts.wfhPending ?? statistics?.pendingWfh ?? 0,
//       path: '/admin/wfh',
//       color: 'bg-cyan-50 border-cyan-200 text-cyan-800',
//       dot: 'bg-cyan-500'
//     },
//     {
//       title: 'Regularization',
//       subtitle: 'Attendance regularization requests',
//       count: counts.attendancePending ?? 0,
//       path: '/admin/attendance-requests',
//       color: 'bg-blue-50 border-blue-200 text-blue-800',
//       dot: 'bg-blue-500'
//     },
//     {
//       title: 'Task Reviews',
//       subtitle: 'Pending task actions',
//       count: counts.taskPending ?? 0,
//       path: '/admin/tasks',
//       color: 'bg-green-50 border-green-200 text-green-800',
//       dot: 'bg-green-500'
//     }
//   ];

//   return (
//     <div className="space-y-8">
//       <div className="space-y-1">
//         <h1 className="text-3xl font-bold tracking-tight text-gray-900">Dashboard</h1>
//         <p className="text-sm text-gray-500">Overview of your HR management system</p>
//       </div>

//       {/* Attendance Summary */}
//       <div className="overflow-hidden rounded-2xl border border-gray-100 bg-white shadow-sm">
//         <div className="border-b border-gray-100 px-6 py-5">
//           <h3 className="text-lg font-semibold text-gray-900">Attendance Summary</h3>
//           <p className="mt-1 text-sm text-gray-500">Click a card to view employees for today by status.</p>
//         </div>
//         <div className="p-6">
//           <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-5">
//             {attendanceCards.map((item) => (
//               <button
//                 key={item.title}
//                 onClick={() => navigate(`/admin/attendance/date-wise/${todayDateString}?status=${item.filter}`)}
//                 className={`group rounded-xl border p-5 text-left shadow-sm transition-all duration-200 hover:-translate-y-0.5 hover:shadow-md focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-gray-300 ${item.bg}`}
//               >
//                 <div className={`text-3xl font-bold tracking-tight ${item.color}`}>{item.value}</div>
//                 <div className="mt-1 text-sm font-medium text-gray-700">{item.title}</div>
//                 <div className="mt-3 text-xs font-medium text-gray-400 transition-colors group-hover:text-gray-600">Open today&apos;s list</div>
//               </button>
//             ))}
//           </div>
//         </div>
//       </div>

//       {/* Quick Request Center */}
//       <div className="overflow-hidden rounded-2xl border border-gray-100 bg-white shadow-sm">
//         <div className="border-b border-gray-100 px-6 py-5">
//           <h3 className="text-lg font-semibold text-gray-900">Request & Notification Center</h3>
//           <p className="mt-1 text-sm text-gray-500">Review pending items and jump directly to the relevant page.</p>
//         </div>
//         <div className="grid grid-cols-1 gap-4 p-6 sm:grid-cols-2 lg:grid-cols-3">
//           {actionableRequests.map((item) => (
//             <button
//               key={item.title}
//               onClick={() => navigate(item.path)}
//               className={`group w-full rounded-xl border p-5 text-left shadow-sm transition-all duration-200 hover:-translate-y-0.5 hover:shadow-md focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-gray-300 ${item.color}`}
//             >
//               <div className="flex items-start justify-between gap-3">
//                 <div className="min-w-0">
//                   <p className="text-sm font-semibold tracking-tight">{item.title}</p>
//                   <p className="mt-1 text-xs leading-relaxed opacity-80">{item.subtitle}</p>
//                 </div>
//                 <ClipboardCheck className="h-5 w-5 shrink-0 opacity-70" />
//               </div>
//               <div className="mt-5 flex items-center justify-between">
//                 <div className="text-3xl font-bold tracking-tight">{item.count}</div>
//                 <span className="inline-flex items-center text-xs font-semibold transition-transform group-hover:translate-x-0.5">
//                   <span className={`mr-2 h-2 w-2 rounded-full ${item.dot}`} />
//                   View
//                 </span>
//               </div>
//             </button>
//           ))}
//         </div>
//       </div>

//       {/* Recent Activities */}
//       <div className="overflow-hidden rounded-2xl border border-gray-100 bg-white shadow-sm">
//         <div className="border-b border-gray-100 px-6 py-5">
//           <h3 className="text-lg font-semibold text-gray-900">Recent Leave Applications</h3>
//         </div>
//         <div className="p-6">
//           {recentActivities?.leaves?.length > 0 ? (
//             <div className="space-y-3">
//               {recentActivities.leaves.filter(leave => leave.userId).map((leave, index) => (
//                 <div key={index} onClick={() => navigate("/admin/leaves")} className="flex items-center justify-between gap-4 rounded-xl border border-gray-100 bg-gray-50/70 p-4 transition-all duration-200 hover:border-gray-200 hover:bg-white hover:shadow-sm cursor-pointer">
//                   <div className="min-w-0 flex-1">
//                     <div className="mb-2 flex items-center justify-between gap-3">
//                       <p className="truncate font-semibold text-gray-900">{leave.userId?.name || 'Unknown User'}</p>
//                       <span className={`shrink-0 rounded-full px-3 py-1 text-xs font-semibold ${
//                         leave.status === 'pending'
//                           ? 'bg-yellow-100 text-yellow-800'
//                           : leave.status === 'approved'
//                           ? 'bg-green-100 text-green-800'
//                           : 'bg-red-100 text-red-800'
//                       }`}>
//                         {leave.status.charAt(0).toUpperCase() + leave.status.slice(1)}
//                       </span>
//                     </div>
//                     <p className="mb-2 break-words text-sm text-gray-600">{leave.reason}</p>
//                     <div className="flex flex-wrap items-center gap-x-4 gap-y-1 text-xs text-gray-500">
//                       <span>{new Date(leave.startDate).toLocaleDateString()} - {new Date(leave.endDate).toLocaleDateString()}</span>
//                       <span>•</span>
//                       <span>{leave.leaveDays?.length || 0} day(s)</span>
//                     </div>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           ) : (
//             <div className="flex flex-col items-center justify-center py-16 text-center">
//               <AlertCircle className="mx-auto h-12 w-12 text-gray-300" />
//               <p className="mt-3 text-sm font-medium text-gray-600">No recent leave applications</p>
//               <p className="mt-1 text-xs text-gray-400">Leave requests will appear here</p>
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Dashboard;

import React, { useState, useEffect } from 'react';
import {
  ClipboardCheck,
  AlertCircle,
  CalendarDays,
  CheckCircle2,
  Clock,
  XCircle,
  Home,
  LogIn
} from 'lucide-react';
import api from '../../services/api';
import LoadingSpinner from '../common/LoadingSpinner';
import { useNavigate } from 'react-router-dom';
import useAdminSidebarCounts from '../../hooks/useAdminSidebarCounts';

const getLocalDateString = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

const normalizeAttendanceStatus = (attendance) => {
  if (attendance?.status === 'full-day' || attendance?.status === 'half-day') {
    return attendance.status;
  }
  if (attendance?.checkInTime && !attendance?.checkOutTime) {
    return 'checked-in';
  }
  if (attendance?.checkInTime && attendance?.checkOutTime) {
    return attendance?.totalHours >= 8 ? 'full-day' : 'half-day';
  }
  return 'absent';
};

const Dashboard = () => {
  const [dashboardData, setDashboardData] = useState(null);
  const [todayAttendanceStats, setTodayAttendanceStats] = useState({
    fullDay: 0,
    halfDay: 0,
    absent: 0,
    checkedIn: 0,
    present: 0
  });
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const { counts } = useAdminSidebarCounts();

  useEffect(() => {
    fetchDashboardData();
    fetchTodayAttendanceStats();
  }, []);

  const fetchDashboardData = async () => {
    try {
      const response = await api.get('/admin/dashboard');
      setDashboardData(response.data);
    } catch (error) {
      console.error('Error fetching dashboard data:', error);
    } finally {
      setLoading(false);
    }
  };

  const fetchTodayAttendanceStats = async () => {
    try {
      const todayDateString = getLocalDateString();
      const response = await api.get(`/admin/attendance/date/${todayDateString}`);
      const data = response.data.attendances || [];

      const fullDay = data.filter((a) => normalizeAttendanceStatus(a) === 'full-day').length;
      const halfDay = data.filter((a) => normalizeAttendanceStatus(a) === 'half-day').length;
      const absent = data.filter((a) => normalizeAttendanceStatus(a) === 'absent').length;
      const checkedIn = data.filter((a) => normalizeAttendanceStatus(a) === 'checked-in').length;

      setTodayAttendanceStats({
        fullDay,
        halfDay,
        absent,
        checkedIn,
        present: fullDay + halfDay + checkedIn
      });
    } catch (error) {
      console.error('Error fetching today attendance stats:', error);
    }
  };

  if (loading) {
    return <LoadingSpinner size="lg" className="mt-8" />;
  }

  const { statistics, recentActivities } = dashboardData || {};
  const todayDateString = getLocalDateString();
  const todayLabel = new Date().toLocaleDateString(undefined, {
    weekday: 'long',
    month: 'short',
    day: 'numeric',
    year: 'numeric'
  });

  const attendanceCards = [
    {
      title: 'Present',
      value: todayAttendanceStats.present,
      icon: CheckCircle2,
      color: 'text-emerald-600',
      iconBg: 'bg-emerald-100 text-emerald-600',
      bg: 'bg-emerald-50 border-emerald-200',
      filter: 'present'
    },
    {
      title: 'Full Day',
      value: todayAttendanceStats.fullDay,
      icon: Clock,
      color: 'text-green-600',
      iconBg: 'bg-green-100 text-green-600',
      bg: 'bg-green-50 border-green-200',
      filter: 'full-day'
    },
    {
      title: 'Absent',
      value: todayAttendanceStats.absent,
      icon: XCircle,
      color: 'text-red-600',
      iconBg: 'bg-red-100 text-red-600',
      bg: 'bg-red-50 border-red-200',
      filter: 'absent'
    },
    {
      title: 'Half Day',
      value: todayAttendanceStats.halfDay,
      icon: Home,
      color: 'text-yellow-600',
      iconBg: 'bg-yellow-100 text-yellow-600',
      bg: 'bg-yellow-50 border-yellow-200',
      filter: 'half-day'
    },
    {
      title: 'Checked In',
      value: todayAttendanceStats.checkedIn,
      icon: LogIn,
      color: 'text-blue-600',
      iconBg: 'bg-blue-100 text-blue-600',
      bg: 'bg-blue-50 border-blue-200',
      filter: 'checked-in'
    }
  ];

  const actionableRequests = [
    {
      title: 'Leave Applications',
      subtitle: 'Pending approvals',
      count: counts.leavePending ?? statistics?.pendingLeaves ?? 0,
      path: '/admin/leaves',
      color: 'bg-yellow-50 border-yellow-200 text-yellow-800',
      dot: 'bg-yellow-500'
    },
    {
      title: 'WFH Applications',
      subtitle: 'Pending work from home requests',
      count: counts.wfhPending ?? statistics?.pendingWfh ?? 0,
      path: '/admin/wfh',
      color: 'bg-green-50 border-green-200 text-green-800',
      dot: 'bg-green-500'
    },
    {
      title: 'Regularization',
      subtitle: 'Attendance regularization requests',
      count: counts.attendancePending ?? 0,
      path: '/admin/attendance-requests',
      color: 'bg-blue-50 border-blue-200 text-blue-800',
      dot: 'bg-blue-500'
    },
    {
      title: 'Task Reviews',
      subtitle: 'Pending task actions',
      count: counts.taskPending ?? 0,
      path: '/admin/tasks',
      color: 'bg-green-50 border-green-200 text-green-800',
      dot: 'bg-green-500'
    }
  ];

  return (
    <div className="space-y-8">
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div className="space-y-1">
          <h1 className="text-3xl font-bold tracking-tight text-gray-900">Dashboard</h1>
          <p className="text-sm text-gray-500">Overview of your HR management system</p>
        </div>
        <div className="flex items-center gap-2 rounded-xl border border-gray-200 bg-white px-3 py-2 text-xs font-medium text-gray-500 shadow-sm">
          <CalendarDays className="h-3.5 w-3.5 text-gray-400" />
          Today &bull; {todayLabel}
        </div>
      </div>

      {/* Attendance Summary */}
      <div className="overflow-hidden rounded-2xl border border-gray-100 bg-white shadow-sm">
        <div className="border-b border-gray-100 px-6 py-5">
          <h3 className="text-lg font-semibold text-gray-900">Attendance Summary</h3>
          <p className="mt-1 text-sm text-gray-500">Click a card to view employees for today by status.</p>
        </div>
        <div className="p-6">
          <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-5">
            {attendanceCards.map((item) => {
              const Icon = item.icon;
              return (
                <button
                  key={item.title}
                  onClick={() => navigate(`/admin/attendance/date-wise/${todayDateString}?status=${item.filter}`)}
                  className={`group relative rounded-xl border p-5 text-left shadow-sm transition-all duration-200 hover:-translate-y-0.5 hover:shadow-md focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-gray-300 ${item.bg}`}
                >
                  <span className={`absolute right-4 top-4 flex h-7 w-7 items-center justify-center rounded-full ${item.iconBg}`}>
                    <Icon className="h-4 w-4" />
                  </span>
                  <div className={`text-3xl font-bold tracking-tight ${item.color}`}>{item.value}</div>
                  <div className="mt-1 text-sm font-medium text-gray-700">{item.title}</div>
                  <div className="mt-3 text-xs font-medium text-gray-400 transition-colors group-hover:text-gray-600">Open today&apos;s list</div>
                </button>
              );
            })}
          </div>
        </div>
      </div>

      {/* Quick Request Center */}
      <div className="overflow-hidden rounded-2xl border border-gray-100 bg-white shadow-sm">
        <div className="border-b border-gray-100 px-6 py-5">
          <h3 className="text-lg font-semibold text-gray-900">Request & Notification Center</h3>
          <p className="mt-1 text-sm text-gray-500">Review pending items and jump directly to the relevant page.</p>
        </div>
        <div className="grid grid-cols-1 gap-4 p-6 sm:grid-cols-2 lg:grid-cols-3">
          {actionableRequests.map((item) => (
            <button
              key={item.title}
              onClick={() => navigate(item.path)}
              className={`group w-full rounded-xl border p-5 text-left shadow-sm transition-all duration-200 hover:-translate-y-0.5 hover:shadow-md focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-gray-300 ${item.color}`}
            >
              <div className="flex items-start justify-between gap-3">
                <div className="min-w-0">
                  <p className="text-sm font-semibold tracking-tight">{item.title}</p>
                  <p className="mt-1 text-xs leading-relaxed opacity-80">{item.subtitle}</p>
                </div>
                <ClipboardCheck className="h-5 w-5 shrink-0 opacity-70" />
              </div>
              <div className="mt-5 flex items-center justify-between">
                <div className="text-3xl font-bold tracking-tight">{item.count}</div>
                <span className="inline-flex items-center text-xs font-semibold transition-transform group-hover:translate-x-0.5">
                  <span className={`mr-2 h-2 w-2 rounded-full ${item.dot}`} />
                  View
                </span>
              </div>
            </button>
          ))}
        </div>
      </div>

      {/* Recent Activities */}
      <div className="overflow-hidden rounded-2xl border border-gray-100 bg-white shadow-sm">
        <div className="border-b border-gray-100 px-6 py-5">
          <h3 className="text-lg font-semibold text-gray-900">Recent Leave Applications</h3>
        </div>
        <div className="p-6">
          {recentActivities?.leaves?.length > 0 ? (
            <div className="space-y-3">
              {recentActivities.leaves.filter(leave => leave.userId).map((leave, index) => (
                <div key={index} onClick={() => navigate("/admin/leaves")} className="flex items-center justify-between gap-4 rounded-xl border border-gray-100 bg-gray-50/70 p-4 transition-all duration-200 hover:border-gray-200 hover:bg-white hover:shadow-sm cursor-pointer">
                  <div className="min-w-0 flex-1">
                    <div className="mb-2 flex items-center justify-between gap-3">
                      <p className="truncate font-semibold text-gray-900">{leave.userId?.name || 'Unknown User'}</p>
                      <span className={`shrink-0 rounded-full px-3 py-1 text-xs font-semibold ${
                        leave.status === 'pending'
                          ? 'bg-yellow-100 text-yellow-800'
                          : leave.status === 'approved'
                          ? 'bg-green-100 text-green-800'
                          : 'bg-red-100 text-red-800'
                      }`}>
                        {leave.status.charAt(0).toUpperCase() + leave.status.slice(1)}
                      </span>
                    </div>
                    <p className="mb-2 break-words text-sm text-gray-600">{leave.reason}</p>
                    <div className="flex flex-wrap items-center gap-x-4 gap-y-1 text-xs text-gray-500">
                      <span>{new Date(leave.startDate).toLocaleDateString()} - {new Date(leave.endDate).toLocaleDateString()}</span>
                      <span>•</span>
                      <span>{leave.leaveDays?.length || 0} day(s)</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="flex flex-col items-center justify-center py-16 text-center">
              <AlertCircle className="mx-auto h-12 w-12 text-gray-300" />
              <p className="mt-3 text-sm font-medium text-gray-600">No recent leave applications</p>
              <p className="mt-1 text-xs text-gray-400">Leave requests will appear here</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
